"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var isNil_1 = (0, tslib_1.__importDefault)(require("lodash/fp/isNil"));
var determineBaseApiUrl = function (apiName, ntConfig) {
    var _a, _b;
    if (!apiName || (0, isNil_1.default)(ntConfig)) {
        throw new Error('API Name and NTConfig are required');
    }
    var Rest = ntConfig.Rest, HTTP = ntConfig.HTTP;
    var baseURL = '';
    if (apiName.toUpperCase().includes('ML')) {
        baseURL = (_a = HTTP === null || HTTP === void 0 ? void 0 : HTTP.MLOApi) === null || _a === void 0 ? void 0 : _a.endpoint;
    }
    else {
        baseURL = (_b = Rest === null || Rest === void 0 ? void 0 : Rest[apiName]) === null || _b === void 0 ? void 0 : _b.endpoint;
    }
    if (!baseURL) {
        throw new Error("No endpoint defined with name ".concat(apiName));
    }
    return baseURL;
};
exports.default = determineBaseApiUrl;
